export default __webpack_public_path__ + "static/media/crown.c5788947.png";